<template>
  <div class="jcy-swiper-container">
    <div  v-if="banners && banners.length" v-swiper:swiper="swiperOption" class="swiper">
      <div class="swiper-wrapper">
        <slot></slot>
      </div>
      <div class="swiper-button-prev page-swiper-prev" slot="button-prev" :class="prevClass" v-show="navigation && banners.length > 1"></div>
      <div class="swiper-button-next page-swiper-next" slot="button-next" :class="nextClass" v-show="navigation && banners.length > 1"></div>
    </div>
    <div v-if="pagination && banners.length > 1" class="swiper-pagination swiper-pagination-bullets" :id="id" :class="bulletsClass"></div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'swiper',
  props: {
    bulletsClass: {
      type: String,
      default: ''
    },
    prevClass: {
      type: String,
      default: ''
    },
    nextClass: {
      type: String,
      default: ''
    },
    banners: {
      type: Array,
      default () {
        return []
      }
    },
    navigation: Boolean,
    props: {
      type: Object,
      default () {
        return {
          imageKey: 'image',
          urlKey: 'url',
          idKey: 'id'
        }
      }
    },
    options: Object,
    pagination: Boolean
  },
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler () {
        // 在swiper未被实例化之前有效，所以需要在给banners赋值之前改变options
        this.swiperOption = _.merge({}, this.swiperOption, this.options)
      }
    }
  },
  data () {
    let id = `swiper-pagination-${new Date().getTime()}`
    return {
      id: id,
      swiperOption: {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        spaceBetween: 0,
        pagination: {
          el: `#${id}`,
          clickable: true
        },
        navigation: {
          nextEl: '.page-swiper-next',
          prevEl: '.page-swiper-prev'
        },
        on: {
          slideChange () {
          },
          tap () {
          }
        }
      }
    }
  },
  methods: {
    onMouseEnter () {
      if (!this.swiper) return
      this.swiper.autoplay.stop()
    },
    onMouseLeave () {
      if (!this.swiper) return
      this.swiper.autoplay.start()
    }
  },
  mounted () {
    this.swiperOption = _.merge({}, this.swiperOption, this.options)
  }
}
</script>

<style lang="scss">
.jcy-swiper-container {
  width: 100%;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  .swiper-slide {
    width: 100%;
    a {
      width: 100%;
      display: inline-block;
    }
  }
}
.swiper-container {
  width: 100%;
}
.swiper-pagination-bullets {
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  .swiper-pagination-bullet {
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4);
    opacity: 1;
    margin-right: 16px;
    transform: scale(1);
    &:last-child {
      margin-right: 0;
    }
    &.swiper-pagination-bullet-active {
      background: #409bff;
      opacity: 1;
      transform: scale(1);
    }
  }
}
.swiper-button-prev {
  opacity: 0.5;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E")!important;
}
.swiper-button-next {
  opacity: 0.5;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E")!important;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/swiper.vue